import React from 'react';

import RoutedHeader from '../Header';
import getFAQs from './getFAQs';
import Question from './Question';

import './styles.css';


const sections = [
  'The Basics',
  'Account Information',
  'For Companies',
  'Offer and Trading Information',
  'Investment Information',
  'General Offer Information',
  'Regulatory Information',
];

const CategorySelector = ({ section }) => (
  <a
    href={`#${section.toLowerCase().replace(/\s/g, '')}`}
    styleName="categorySelector"
  >
    { section }
  </a>
);

const FAQSection = ({ title, questions, id }) => (
  <div
    id={id}
    styleName="faqSectionBox"
  >
    <div styleName="sectionHeader">
      { title }
    </div>
    <div>
      { questions.map(q => (
        <Question
          key={`${id}+${q.question.toLowerCase().replace(/\s/g, '')}`}
          question={q.question}
          answer={q.answerComp}
        />
        ))
      }
    </div>
  </div>
);

const Component = () => {
  const categorySelectors = sections.map(s => (
    <CategorySelector section={s} key={s} />
  ));

  const faqs = getFAQs();
  const faqSections = sections.map((s) => {
    const modifiedS = s.toLowerCase().replace(/\s/g, '');
    return (
      <FAQSection
        key={modifiedS}
        title={s}
        questions={faqs[modifiedS]}
        id={modifiedS}
      />
    );
  });

  return (
    <div>
      <RoutedHeader />
      <div styleName="container">
        <div styleName="subContainer">
          <div styleName="contentsSection">
            <div styleName="faqHeader">
              Frequently Asked Questions
            </div>
            <div styleName="faqSubHeader">
              Can&apos;t find an answer to your question? Contact us at <a href="mailto:clientservices@myipo.com">clientservices@myipo.com</a>.
            </div>
          </div>
          <div styleName="categoryContainer">
            { categorySelectors }
          </div>
          <div styleName="faqAnswersContainer">
            { faqSections }
          </div>
        </div>
      </div>
    </div>
  );
};

Component.displayName = 'FAQ';

export default Component;



// WEBPACK FOOTER //
// ./src/components/FAQ/index.js